interface IENV {
  appCode: string
  apiEndpoint: string
  envType?: string
  portalGetway: string
  /** chat-service through the gateway, for the topbar's Chat launcher. Empty = no launcher. */
  chatGetway: string
  portalURL?: string
  /**
   * Origin of `portalURL` — the Portal host, for cross-app links such as the module switcher.
   * Derived once here rather than at each call site, which is how two of those links ended up
   * hardcoded to portal.erpboi.com. Empty string when portalURL is unset or malformed.
   */
  portalOrigin: string
  /** The Help page's support address. */
  supportEmail: string
  hrmGetway: string
}

const originOf = (url?: string): string => {
  try {
    return new URL(url || '').origin
  } catch {
    return ''
  }
}

export const ENV: IENV = {
  appCode: process.env.REACT_APP_CODE || '',
  envType: process.env.REACT_APP_ENV_TYPE || '',
  apiEndpoint: process.env.REACT_APP_GETWAY || '',
  portalURL: process.env.REACT_APP_PORTAL_URL || '',
  portalOrigin: originOf(process.env.REACT_APP_PORTAL_URL),
  supportEmail: process.env.REACT_APP_SUPPORT_EMAIL || 'support@erpboi.com',
  portalGetway: process.env.REACT_APP_PORTAL_GETWAY || '',
  chatGetway: process.env.REACT_APP_CHAT_GETWAY || '',
  // ITAM has no employee directory of its own — "assigned employee" references
  // hrm-service's directory directly (same shared Portal token authenticates both).
  hrmGetway: process.env.REACT_APP_HRM_GETWAY || '',
}
